import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '@/views/HomeView.vue'
// import MainGaolu from '@/views/MainGaolu.vue'
// import RoofSystem from '@/views/RoofSystem.vue'
// import HotBlastSystem from "@/views/HotBlastSystem.vue"
// import UnderGrooveSystem from "@/views/UnderGrooveSystem.vue"
const HomeView =() => import('@/views/HomeView.vue')
const MainGaolu =() => import('@/views/MainGaolu.vue')
const RoofSystem =() => import('@/views/RoofSystem.vue')
const HotBlastSystem =() => import("@/views/HotBlastSystem.vue")
const UnderGrooveSystem = () => import('@/views/UnderGrooveSystem.vue')
Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/furnacebody',
    component: MainGaolu
  },
  {
    path:'/roofsystem',
    component: RoofSystem
  },
  {
    path: '/hotblastsystem',
    component: HotBlastSystem
  },
  {
    path: '/undergroovesystem',
    component: UnderGrooveSystem
  },
  {
    // path: '/',
    // 使用通配符
    path: '*',
    redirect: '/home'
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

//解决路由重复点击报错
const originalReplace = VueRouter.prototype.replace;
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};

export default router
